import { Pipe, PipeTransform, inject, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { I18nService } from '../../core/services/i18n.service';

@Pipe({
  name: 'i18n',
  standalone: true,
  pure: false, // Permite detecção de mudanças quando o idioma muda
})
export class I18nPipe implements PipeTransform, OnDestroy {
  private i18nService = inject(I18nService);
  private cdr = inject(ChangeDetectorRef);
  private subscription?: Subscription;
  private lastKey = '';
  private lastValue = '';

  transform(key: string, params?: Record<string, string | number>): string {
    if (!key) {
      return '';
    }

    // Se a chave mudou, cancela a assinatura anterior
    if (this.lastKey !== key) {
      this.unsubscribe();
      this.lastKey = key;
    }

    // Obtém o valor atual de forma síncrona
    const currentValue = this.i18nService.instant(key, params);

    // Se o valor mudou, atualiza
    if (this.lastValue !== currentValue) {
      this.lastValue = currentValue;
    }

    // Se ainda não há assinatura, cria uma para detectar mudanças de idioma
    if (!this.subscription) {
      this.subscription = this.i18nService.getCurrentLanguage().subscribe(() => {
        const newValue = this.i18nService.instant(key, params);
        if (this.lastValue !== newValue) {
          this.lastValue = newValue;
          this.cdr.markForCheck();
        }
      });
    }

    return this.lastValue;
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}

